export default "__VITE_ASSET__780a369e__"